import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\LibraryController::index
* @see Http/Controllers/LibraryController.php:135
* @route '/library'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/library',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LibraryController::index
* @see Http/Controllers/LibraryController.php:135
* @route '/library'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LibraryController::index
* @see Http/Controllers/LibraryController.php:135
* @route '/library'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LibraryController::index
* @see Http/Controllers/LibraryController.php:135
* @route '/library'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LibraryController::index
* @see Http/Controllers/LibraryController.php:135
* @route '/library'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LibraryController::index
* @see Http/Controllers/LibraryController.php:135
* @route '/library'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LibraryController::index
* @see Http/Controllers/LibraryController.php:135
* @route '/library'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\LibraryController::store
* @see Http/Controllers/LibraryController.php:28
* @route '/library/files'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/library/files',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\LibraryController::store
* @see Http/Controllers/LibraryController.php:28
* @route '/library/files'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LibraryController::store
* @see Http/Controllers/LibraryController.php:28
* @route '/library/files'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\LibraryController::store
* @see Http/Controllers/LibraryController.php:28
* @route '/library/files'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\LibraryController::store
* @see Http/Controllers/LibraryController.php:28
* @route '/library/files'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\LibraryController::bulkDelete
* @see Http/Controllers/LibraryController.php:104
* @route '/library/files/bulk-delete'
*/
export const bulkDelete = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkDelete.url(options),
    method: 'post',
})

bulkDelete.definition = {
    methods: ["post"],
    url: '/library/files/bulk-delete',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\LibraryController::bulkDelete
* @see Http/Controllers/LibraryController.php:104
* @route '/library/files/bulk-delete'
*/
bulkDelete.url = (options?: RouteQueryOptions) => {
    return bulkDelete.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LibraryController::bulkDelete
* @see Http/Controllers/LibraryController.php:104
* @route '/library/files/bulk-delete'
*/
bulkDelete.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkDelete.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\LibraryController::bulkDelete
* @see Http/Controllers/LibraryController.php:104
* @route '/library/files/bulk-delete'
*/
const bulkDeleteForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkDelete.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\LibraryController::bulkDelete
* @see Http/Controllers/LibraryController.php:104
* @route '/library/files/bulk-delete'
*/
bulkDeleteForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkDelete.url(options),
    method: 'post',
})

bulkDelete.form = bulkDeleteForm

/**
* @see \App\Http\Controllers\LibraryController::finalize
* @see Http/Controllers/LibraryController.php:63
* @route '/library/files/{file}/finalize'
*/
export const finalize = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: finalize.url(args, options),
    method: 'post',
})

finalize.definition = {
    methods: ["post"],
    url: '/library/files/{file}/finalize',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\LibraryController::finalize
* @see Http/Controllers/LibraryController.php:63
* @route '/library/files/{file}/finalize'
*/
finalize.url = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { file: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { file: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            file: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        file: typeof args.file === 'object'
        ? args.file.id
        : args.file,
    }

    return finalize.definition.url
            .replace('{file}', parsedArgs.file.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LibraryController::finalize
* @see Http/Controllers/LibraryController.php:63
* @route '/library/files/{file}/finalize'
*/
finalize.post = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: finalize.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\LibraryController::finalize
* @see Http/Controllers/LibraryController.php:63
* @route '/library/files/{file}/finalize'
*/
const finalizeForm = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: finalize.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\LibraryController::finalize
* @see Http/Controllers/LibraryController.php:63
* @route '/library/files/{file}/finalize'
*/
finalizeForm.post = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: finalize.url(args, options),
    method: 'post',
})

finalize.form = finalizeForm

/**
* @see \App\Http\Controllers\LibraryController::download
* @see Http/Controllers/LibraryController.php:125
* @route '/library/files/{file}/download'
*/
export const download = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

download.definition = {
    methods: ["get","head"],
    url: '/library/files/{file}/download',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LibraryController::download
* @see Http/Controllers/LibraryController.php:125
* @route '/library/files/{file}/download'
*/
download.url = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { file: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { file: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            file: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        file: typeof args.file === 'object'
        ? args.file.id
        : args.file,
    }

    return download.definition.url
            .replace('{file}', parsedArgs.file.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LibraryController::download
* @see Http/Controllers/LibraryController.php:125
* @route '/library/files/{file}/download'
*/
download.get = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LibraryController::download
* @see Http/Controllers/LibraryController.php:125
* @route '/library/files/{file}/download'
*/
download.head = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: download.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LibraryController::download
* @see Http/Controllers/LibraryController.php:125
* @route '/library/files/{file}/download'
*/
const downloadForm = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LibraryController::download
* @see Http/Controllers/LibraryController.php:125
* @route '/library/files/{file}/download'
*/
downloadForm.get = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LibraryController::download
* @see Http/Controllers/LibraryController.php:125
* @route '/library/files/{file}/download'
*/
downloadForm.head = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

download.form = downloadForm

/**
* @see \App\Http\Controllers\LibraryController::destroy
* @see Http/Controllers/LibraryController.php:92
* @route '/library/files/{file}'
*/
export const destroy = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/library/files/{file}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\LibraryController::destroy
* @see Http/Controllers/LibraryController.php:92
* @route '/library/files/{file}'
*/
destroy.url = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { file: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { file: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            file: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        file: typeof args.file === 'object'
        ? args.file.id
        : args.file,
    }

    return destroy.definition.url
            .replace('{file}', parsedArgs.file.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LibraryController::destroy
* @see Http/Controllers/LibraryController.php:92
* @route '/library/files/{file}'
*/
destroy.delete = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\LibraryController::destroy
* @see Http/Controllers/LibraryController.php:92
* @route '/library/files/{file}'
*/
const destroyForm = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\LibraryController::destroy
* @see Http/Controllers/LibraryController.php:92
* @route '/library/files/{file}'
*/
destroyForm.delete = (args: { file: string | number | { id: string | number } } | [file: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const LibraryController = { index, store, bulkDelete, finalize, download, destroy }

export default LibraryController